import React from 'react';
import { FDContentContainer, FDStack } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import useMobileLayout from 'Hooks/useMobileLayout';
import MobileLayout from 'Views/Page/Content/Templates/CapitalizeRolloverIntroStepTemplate/Content/MobileLayout';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PropTypes from 'prop-types';
import Layout from './Layout';
import { metaOverrideSet } from '../metaOverride';

const Content = ({ errors }) => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  const layout = isMobile ? MobileLayout : Layout;

  return (
    <LottieLoadingLayout>
      <FDContentContainer maxWidth={'md'}>
        <FDStack direction={'column'} alignItems={'center'} spacing={3}>
          <MetaResourceRenderer
            resource={resource}
            layout={layout}
            LayoutProps={{
              errors,
            }}
            metaOverrideSet={metaOverrideSet}
          />
        </FDStack>
      </FDContentContainer>
    </LottieLoadingLayout>
  );
};

Content.defaultProps = {
  errors: [],
};

Content.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object),
};

export default Content;
